import { Route } from '@angular/router';

import {
  PageChangelogComponent,
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { authorizationGuardFn } from '@infodata-group/inf-commons';

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: PageLoginComponent,
  },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [authorizationGuardFn],
    children: [
      {
        path: 'salary',
        loadComponent: () =>
          import('./page/page-salary/page-salary.component').then(
            (m) => m.PageSalaryComponent,
          ),
      },
      { path: '', redirectTo: 'salary', pathMatch: 'full' },
      {
        path: 'stat',
        loadComponent: () =>
          import('./page/page-powerbi/page-powerbi.component').then(
            (m) => m.PagePowerbiComponent,
          ),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./page/page-details/page-details.component').then(
            (m) => m.PageDetailsComponent,
          ),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('./page/page-salary-edit/page-salary-edit.component').then(
            (m) => m.PageSalaryEditComponent,
          ),
      },
      {
        path: 'chart',
        loadComponent: () =>
          import('./page/page-chart/page-chart.component').then(
            (m) => m.PageChartComponent,
          ),
      },
      { path: 'changelogs', component: PageChangelogComponent },
    ],
  },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  {
    path: 'reset-request',
    component: PageResetRequestComponent,
  },
  {
    path: 'reset-password',
    component: PagePwdResetComponent,
  },
];
